/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-05-27 18:06:44
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-11-19 16:38:55
 * @Description: file content
 */
import Cookies from "js-cookie";
import global_ from "../global.config";
import Qs from "qs";
import { MessageBox, Toast } from "mint-ui";
import wx from "weixin-js-sdk";
import wxsdk from "@/utils/wxsdk";
import request from "@/utils/request";
import CryptoJS from "crypto-js";

export default {
  config: {
    storageKey: {
      isAutoEntryChatDialog: "isAutoEntryChatDialog"
    },
    interval: {
      getChatList: null
    }
  },
  // 是否是在线售楼中心
  checkIsZxslzx() {
    if (
      location.href.indexOf("/t9") > -1 ||
      location.href.indexOf("entry=zxslzx") > -1 ||
      (location.href.indexOf("t9id=") > -1 &&
        location.href.indexOf("t9psn=") > -1)
    ) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否是测试环境 因为华发的测试环境也是qmyx开头的子域名 huafacrm是华发的主域名
  checkIsTest() {
    if (
      global_.SUBDOMAIN == "qmyx" &&
      location.host.indexOf(".huafacrm.") == -1
    ) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 是否部署过独立小程序
   */
  checkIsHaveOldMp() {
    /**
     * 悦房云 yuefangy
     * 江西万科 jxwk
     * 安联e家 alej
     * 正宏置业 zhzy
     * 联实 lianshi
     * 原圈云 yuanquan
     */
    let domainList = [
      // "yuefangy",
      // "jxwk",
      // "alej",
      // "zhzy",
      // "lianshi",
      // "yuanquan"
    ];
    let isHave = false;
    domainList.forEach(item => {
      if (location.host.indexOf(`${item}.`) > -1) {
        isHave = true;
      }
    });
    return isHave;
  },
  /**
   * 在request里面也做了判断，需要改的时候，请同步更改
   */
  checkIsHuafa: function () {
    if (location.host.indexOf("localhost") > -1) {
      if (
        global_.API_DOMAIN.indexOf("huafacrm") > -1 ||
        global_.API_DOMAIN.indexOf("huafamarkting") > -1
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        location.host.indexOf(".huafacrm.") > -1 ||
        location.host.indexOf(".huafamarkting.") > -1
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  checkIsHuafaTest() {
    if (location.host.indexOf("localhost") > -1) {
      if (global_.API_DOMAIN.indexOf("huafacrm") > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      if (location.host.indexOf(".huafacrm.") > -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  checkIsHuafaPro() {
    if (location.host.indexOf("localhost") > -1) {
      if (global_.API_DOMAIN.indexOf("huafamarkting") > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      if (location.host.indexOf(".huafamarkting.") > -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  getOriginalId() {
    if (this.checkIsHuafaTest()) {
      return "gh_40450f92d041";
    } else if (this.checkIsHuafaPro()) {
      return "gh_5844ca4df353";
    } else if (this.checkIsLianShi()) {
      return "gh_4ebfa0dbef48";
    }
  },
  // 正宏置业
  checkIsZd() {
    if (location.host.indexOf("zhzy.") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 安联
  checkIsAlej() {
    if (global_.SUBDOMAIN == "alej") {
      return true;
    } else {
      return false;
    }
  },
  // 汇龙地产
  checkIsHldc() {
    if (global_.SUBDOMAIN == "hldc") {
      return true;
    } else {
      return false;
    }
  },
  // 汇龙集团旗下
  checkIsHljt() {
    // hldc汇龙地产、hlbldjq巴黎第九区、hljxsf玖玺首府、hlwtsmdj牡丹江外滩首府、hljhj玖和琚
    if (global_.SUBDOMAIN == "hldc" || global_.SUBDOMAIN == "hlbldjq" || global_.SUBDOMAIN == "hljxsf" || global_.SUBDOMAIN == "hlwtsmdj" || global_.SUBDOMAIN == "hljhj") {
      return true;
    } else {
      return false;
    }
  },
  // 润亿网络科技
  checkIsRunYiWangLuo() {
    if (location.host.indexOf("rywlkj.") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 硕丰慧生活
  checkIsSf() {
    if (location.host.indexOf("sfhsh.") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 江西万科
  checkIsJxwk() {
    if (location.host.indexOf("jxwk.") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 天纵时代天樾
  checkIsSdty() {
    if (location.host.indexOf("sdty.") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 九维地产
  checkIsJwdc() {
    if (global_.SUBDOMAIN == "jwdc") {
      return true;
    } else {
      return false;
    }
  },
  //九烨鼎观世界
  checkIsJydgsj() {
    if (location.host.indexOf("jydgsj.") > -1) {
      return true;
    } else {
      return false;
    }
  },
  //莱佛士教育
  checkIsShlfsj() {
    if (global_.SUBDOMAIN == "shlfsj") {
      return true;
    } else {
      return false;
    }
  },
  //黑龙滩
  checkIsHltcd() {
    if (global_.SUBDOMAIN == "hltcd") {
      return true;
    } else {
      return false;
    }
  },
  //东方大道红花PARK
  checkIsDfddhhp() {
    if (global_.SUBDOMAIN == "dfddhhp") {
      return true;
    } else {
      return false;
    }
  },
  //凯辰玥明台
  checkIsHsm() {
    if (global_.SUBDOMAIN == "hsm") {
      return true;
    } else {
      return false;
    }
  },
  // 联实
  checkIsLianShi() {
    if (global_.SUBDOMAIN == "lianshi") {
      return true;
    } else {
      return false;
    }
  },
  // 新八世纪华城
  checkIsXbsjhcws() {
    if (global_.SUBDOMAIN == "xbsjhcws") {
      return true;
    } else {
      return false;
    }
  },
  // 百川锦尚在空港
  checkIsBcjszk() {
    if (global_.SUBDOMAIN == "bcjszk") {
      return true;
    } else {
      return false;
    }
  },
  // 安家浙里
  checkIsAjzl() {
    if (global_.SUBDOMAIN == "ajzl") {
      return true;
    } else {
      return false;
    }
  },
  // 打开 yq-rs-make 代码库的链接，需要的是完整路径的链接包括协议,之所以这么做是为了兼容小程序的新打开webview情况
  openYqRsMakeLink(url, mpRouteType) {
    let link = ""; // 新链接
    // 如果是本地环境就替换为本地的域名
    if (myVue.global.isLoc) {
      let tmpHost = this.getHostFromUrl(url);
      if (tmpHost) {
        url = url.replace(tmpHost, "localhost:2002");
      }
    }
    if (this.getUrlRemoveParams(url).indexOf("coupon") > -1) {
      // 要往优惠购里面跳转，设置参数 ，发起的跳转可能是售楼中心也可能是项目详情
      link = this.addUrlParamFromObj(
        this.getUrlRemoveParams(url),
        this.mixin(
          myVue.$store.state.receiveSpreadInfo,
          this.getParamFromUrl(url)
        )
      );
    } else if (myVue.$route.matched[1].name == "LayoutFound4") {
      // 当前在LayoutFound4下 售楼中心
      if (
        url.indexOf("/t7?id=") > -1 &&
        url.indexOf("&psn=") > -1 &&
        url.indexOf("topfrom=t9_project") > -1
      ) {
        // 项目列表
        link = this.addUrlParamFromObj(url, {
          refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
          rscuid: myVue.$store.state.receiveSpreadInfo.rscuid
        });
      } else if (url.indexOf("/t7?id=") > -1 && url.indexOf("&psn=") > -1) {
        // 如果是是要打开项目详情页 例如 https://qmyx.huafacrm.com/h5/t7?id=66885&psn=5dff1de48a494eeda7b1446500eed215
        // 需要把LayoutFound4的id换成t9id
        link = this.addUrlParamFromObj(url, {
          refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
          rscuid: myVue.$store.state.receiveSpreadInfo.rscuid,
          entry: myVue.$store.state.receiveSpreadInfo.entry,
          t9id: myVue.$store.state.receiveSpreadInfo.id,
          t9psn: myVue.$store.state.receiveSpreadInfo.psn
        });
      } else {
        link = this.addUrlParamFromObj(
          this.getUrlRemoveParams(url),
          this.mixin(
            myVue.$store.state.receiveSpreadInfo,
            this.getParamFromUrl(url)
          )
        );
      }
    } else if (myVue.$route.matched[1].name == "LayoutFound3") {
      // 当前在LayoutFound3下 项目详情
      link = this.addUrlParamFromObj(
        this.getUrlRemoveParams(url),
        this.mixin(
          myVue.$store.state.receiveSpreadInfo,
          this.getParamFromUrl(url)
        )
      );
    } else if (
      myVue.$route.name == "sysintro" ||
      (url.indexOf("miniproj") > -1 && url.indexOf("from=sysintro") > -1)
    ) {
      // 当前页面是 sysintro 售楼中心列表页，里面的所有点击都是打开售楼中心
      // 要往售楼中心首页跳转，设置参数
      // 例如 https://qmyx.huafacrm.com/h5/t9?id=66807&psn=986ab29d236e4011806ae087d8d434da
      // 当切换的售楼中心还是当前的售楼中心，那就要把传播参数带上。如果不是当前的售楼中心，则不用带上传播参数，因为不是同一个公众号。
      let urlParam = this.getParamFromUrl(url);
      if (urlParam.id == myVue.$store.state.receiveSpreadInfo.id) {
        link = this.addUrlParamFromObj(url, {
          refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
          rscuid: myVue.$store.state.receiveSpreadInfo.rscuid
        });
      } else {
        link = url;
      }
    } else {
      link = this.addUrlParamFromObj(
        this.getUrlRemoveParams(url),
        this.mixin(
          myVue.$store.state.receiveSpreadInfo,
          this.getParamFromUrl(url)
        )
      );
    }

    // 如果是华发的环境，则openUrl根据是否是小程序进行页面打开
    if (this.checkIsHuafa()) {
      if (
        myVue.$route.name == "sysintro" ||
        (url.indexOf("miniproj") > -1 && url.indexOf("from=sysintro") > -1)
      ) {
        this.openUrl(link, "reLaunch");
      } else if (link.indexOf("/t9_my") > -1) {
        this.openUrl(link, "reLaunch");
      } else {
        this.openUrl(link);
      }
    } else {
      this.openUrl(link, mpRouteType);
    }
  },
  // 获取 yq-rs-make 代码库的链接，需要的是完整路径的链接包括协议,之所以这么做是为了兼容小程序的新打开webview情况
  //返回url中?后面拼接的参数,用于router跳转
  getYqRsMakeLink(url, mpRouteType) {
    let link = ""; // 新链接
    // 如果是本地环境就替换为本地的域名
    if (myVue.global.isLoc) {
      let tmpHost = this.getHostFromUrl(url);
      if (tmpHost) {
        url = url.replace(tmpHost, "localhost:2002");
      }
    }
    if (this.getUrlRemoveParams(url).indexOf("coupon") > -1) {
      // 要往优惠购里面跳转，设置参数 ，发起的跳转可能是售楼中心也可能是项目详情
      link = this.addUrlParamFromObj(
        this.getUrlRemoveParams(url),
        this.mixin(
          myVue.$store.state.receiveSpreadInfo,
          this.getParamFromUrl(url)
        )
      );
    } else if (myVue.$route.matched[1].name == "LayoutFound4") {
      // 当前在LayoutFound4下 售楼中心
      if (
        url.indexOf("/t7?id=") > -1 &&
        url.indexOf("&psn=") > -1 &&
        url.indexOf("topfrom=t9_project") > -1
      ) {
        // 项目列表
        link = this.addUrlParamFromObj(url, {
          refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
          rscuid: myVue.$store.state.receiveSpreadInfo.rscuid
        });
      } else if (url.indexOf("/t7?id=") > -1 && url.indexOf("&psn=") > -1) {
        // 如果是是要打开项目详情页 例如 https://qmyx.huafacrm.com/h5/t7?id=66885&psn=5dff1de48a494eeda7b1446500eed215
        // 需要把LayoutFound4的id换成t9id
        link = this.addUrlParamFromObj(url, {
          refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
          rscuid: myVue.$store.state.receiveSpreadInfo.rscuid,
          entry: myVue.$store.state.receiveSpreadInfo.entry,
          t9id: myVue.$store.state.receiveSpreadInfo.id,
          t9psn: myVue.$store.state.receiveSpreadInfo.psn
        });
      } else {
        link = this.addUrlParamFromObj(
          this.getUrlRemoveParams(url),
          this.mixin(
            myVue.$store.state.receiveSpreadInfo,
            this.getParamFromUrl(url)
          )
        );
      }
    } else if (myVue.$route.matched[1].name == "LayoutFound3") {
      // 当前在LayoutFound3下 项目详情
      link = this.addUrlParamFromObj(
        this.getUrlRemoveParams(url),
        this.mixin(
          myVue.$store.state.receiveSpreadInfo,
          this.getParamFromUrl(url)
        )
      );
    } else if (
      myVue.$route.name == "sysintro" ||
      (url.indexOf("miniproj") > -1 && url.indexOf("from=sysintro") > -1)
    ) {
      // 当前页面是 sysintro 售楼中心列表页，里面的所有点击都是打开售楼中心
      // 要往售楼中心首页跳转，设置参数
      // 例如 https://qmyx.huafacrm.com/h5/t9?id=66807&psn=986ab29d236e4011806ae087d8d434da
      // 当切换的售楼中心还是当前的售楼中心，那就要把传播参数带上。如果不是当前的售楼中心，则不用带上传播参数，因为不是同一个公众号。
      let urlParam = this.getParamFromUrl(url);
      if (urlParam.id == myVue.$store.state.receiveSpreadInfo.id) {
        link = this.addUrlParamFromObj(url, {
          refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
          rscuid: myVue.$store.state.receiveSpreadInfo.rscuid
        });
      } else {
        link = url;
      }
    } else {
      link = this.addUrlParamFromObj(
        this.getUrlRemoveParams(url),
        this.mixin(
          myVue.$store.state.receiveSpreadInfo,
          this.getParamFromUrl(url)
        )
      );
    }

    // 如果是华发的环境，则openUrl根据是否是小程序进行页面打开
    if (this.checkIsHuafa()) {
      if (
        myVue.$route.name == "sysintro" ||
        (url.indexOf("miniproj") > -1 && url.indexOf("from=sysintro") > -1)
      ) {
        return this.getUrl2(link, "reLaunch");
      } else if (link.indexOf("/t9_my") > -1) {
        return this.getUrl2(link, "reLaunch");
      } else {
        return this.getUrl2(link);
      }
    } else {
      return this.getUrl2(link, mpRouteType);
    }
  },
  // 打开 yq-rs-h5 代码库的链接，需要的是完整路径的链接包括协议
  openYqRsH5Link(url) {
    let link = ""; // 新链接
    // 如果是本地环境就替换为本地的域名
    if (myVue.global.isLoc) {
      let tmpHost = this.getHostFromUrl(url);
      if (tmpHost) {
        if (this.checkIsHuafa()) {
          url = url.replace(
            tmpHost + "/h5",
            "localhost:2000/gong/yuanquan/yq-rs-h5-huafa/src"
          );
        } else {
          url = url.replace(
            tmpHost + "/h5",
            "localhost:2000/gong/yuanquan/yq-rs-h5/src"
          );
        }
      }
    }
    // 也带上传播参数，但是不要覆盖掉链接上自定义的参数
    let newSpreadInfo = {
      refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
      rscuid: myVue.$store.state.receiveSpreadInfo.rscuid,
      entry: "zxslzx",
      t9id:
        myVue.$store.state.receiveSpreadInfo.t9id ||
        myVue.$store.state.receiveSpreadInfo.id,
      t9psn:
        myVue.$store.state.receiveSpreadInfo.t9psn ||
        myVue.$store.state.receiveSpreadInfo.psn
    };
    link = this.addUrlParamFromObj(
      this.getUrlRemoveParams(url),
      this.mixin(newSpreadInfo, this.getParamFromUrl(url))
    );
    // t1、t2、t10带上授权参数在打开yq-rs-h5后免再次授权
    if (
      link.indexOf("/t1.html") > -1 ||
      link.indexOf("/t2.html") > -1 ||
      link.indexOf("/t10.html") > -1
    ) {
      if (
        myVue.$store.state.userInfo &&
        myVue.$store.state.userInfo.user &&
        myVue.$store.state.userInfo.user.appid &&
        myVue.$store.state.userInfo.user.openid &&
        myVue.$store.state.userInfo.user.passport
      ) {
        link += `&j=${encodeURIComponent(
          JSON.stringify({
            appid: myVue.$store.state.userInfo.user.appid,
            openid: myVue.$store.state.userInfo.user.openid,
            passport: myVue.$store.state.userInfo.user.passport
          })
        )}`;
      }
    }
    // 要打开的是vr模板且当前链接是t7或vr演示版带上项目参数
    if (link.indexOf("/t10.html") > -1) {
      if (
        (location.href.indexOf("/t7?") > -1 ||
          location.href.indexOf("/vrdemo?") > -1) &&
        myVue.$route.query.id &&
        myVue.$route.query.psn
      ) {
        link = this.addUrlParamFromObj(
          this.getUrlRemoveParams(link),
          this.mixin(
            {
              t7id: myVue.$route.query.id,
              t7psn: myVue.$route.query.psn
            },
            this.getParamFromUrl(link)
          )
        );
      }
    }

    this.openUrl(link);
  },
  // 打开 shqc-web 代码库的链接，需要的是完整路径的链接包括协议
  openShqcWebLink(url) {
    let link = "";
    // 如果是本地环境就替换为本地的域名
    if (myVue.global.isLoc) {
      let tmpHost = this.getHostFromUrl(url);
      if (tmpHost) {
        if (this.checkIsHuafa()) {
          url = url.replace(
            tmpHost + "/marketies/rc",
            "localhost:2000/gong/yuanquan/shqc-web-huafa/marketies/rc"
          );
          url = this.addUrlParamFromObj(url, {
            fake: "qmyx_hope"
          });
        } else {
          url = url.replace(
            tmpHost + "/marketies/rc",
            "localhost:2000/gong/yuanquan/shqc-web/marketies/rc"
          );
          url = this.addUrlParamFromObj(url, {
            fake: "qmyx_hope"
          });
        }
      }
    }
    // 也带上传播参数，但是不要覆盖掉链接上自定义的参数
    let newSpreadInfo = {
      refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
      rscuid: myVue.$store.state.receiveSpreadInfo.rscuid,
      entry: "zxslzx",
      t9id:
        myVue.$store.state.receiveSpreadInfo.t9id ||
        myVue.$store.state.receiveSpreadInfo.id,
      t9psn:
        myVue.$store.state.receiveSpreadInfo.t9psn ||
        myVue.$store.state.receiveSpreadInfo.psn
    };
    link = this.addUrlParamFromObj(
      this.getUrlRemoveParams(url),
      this.mixin(newSpreadInfo, this.getParamFromUrl(url))
    );
    // 小程序环境下添加mp参数，让请求用一个子域名
    if (myVue.$store.state.isInMiniProgram) {
      link = this.addUrlParamFromObj(link, {
        evn: "mp"
      });
    }
    this.openUrl(link);
  },
  // 打开 yq-chat-web 代码库的链接，需要的是完整路径的链接包括协议 forceWeb true web方式打开。directType
  openYqChatWeb(url, forceWeb, directType) {
    let link = "";
    // 如果是本地环境就替换为本地的域名
    if (myVue.global.isLoc) {
      let tmpHost = this.getHostFromUrl(url);
      if (tmpHost) {
        if (this.checkIsHuafa()) {
          url = url.replace(tmpHost + "/yqim/chat", "localhost:2005/yqim/chat");
          url = this.addUrlParamFromObj(url, {
            fake: "qmyx_hope"
          });
        } else {
          url = url.replace(tmpHost + "/yqim/chat", "localhost:2005/yqim/chat");
          url = this.addUrlParamFromObj(url, {
            fake: "qmyx_hope"
          });
        }
      }
    }
    // 也带上传播参数，但是不要覆盖掉链接上自定义的参数
    let newSpreadInfo = {
      refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
      rscuid: myVue.$store.state.receiveSpreadInfo.rscuid,
      entry: "zxslzx",
      t9id:
        myVue.$store.state.receiveSpreadInfo.t9id ||
        myVue.$store.state.receiveSpreadInfo.id,
      t9psn:
        myVue.$store.state.receiveSpreadInfo.t9psn ||
        myVue.$store.state.receiveSpreadInfo.psn
    };
    link = this.addUrlParamFromObj(
      this.getUrlRemoveParams(url),
      this.mixin(newSpreadInfo, this.getParamFromUrl(url))
    );
    if (forceWeb) {
      if (directType == "replace") {
        location.replace(link);
      } else {
        location.href = link;
      }
    } else {
      this.openUrl(link);
    }
  },
  openChatDialog(fid, forceWeb, directType) {
    let url = `${location.protocol}//${location.host}/yqim/chat?fid=${fid}`;
    this.openYqChatWeb(url, forceWeb, directType);
  },
  // 打开链接带上传播参数
  openOtherLink(url) {
    let link = "";
    // 如果是本地环境就替换为本地的域名
    if (myVue.global.isLoc) {
      let tmpHost = this.getHostFromUrl(url);
      if (tmpHost) {
        if (this.checkIsHuafa()) {
          url = url.replace(tmpHost, "localhost:2000");
        } else {
          url = url.replace(tmpHost, "localhost:2000");
        }
      }
    }
    // 也带上传播参数，但是不要覆盖掉链接上自定义的参数
    let newSpreadInfo = {
      refereeopenid: myVue.$store.state.receiveSpreadInfo.refereeopenid,
      rscuid: myVue.$store.state.receiveSpreadInfo.rscuid,
      entry: "zxslzx",
      t9id:
        myVue.$store.state.receiveSpreadInfo.t9id ||
        myVue.$store.state.receiveSpreadInfo.id,
      t9psn:
        myVue.$store.state.receiveSpreadInfo.t9psn ||
        myVue.$store.state.receiveSpreadInfo.psn
    };
    link = this.addUrlParamFromObj(
      this.getUrlRemoveParams(url),
      this.mixin(newSpreadInfo, this.getParamFromUrl(url))
    );
    // 如果是/h5/t1.html和/h5/t2.html 把免授权参数也带过去
    if (
      this.getUrlRemoveParams(url).indexOf("/h5/t1.html") > -1 ||
      this.getUrlRemoveParams(url).indexOf("/h5/t2.html") > -1
    ) {
      // 带上授权参数在打开yq-rs-h5后免再次授权
      if (
        myVue.$store.state.userInfo &&
        myVue.$store.state.userInfo.user &&
        myVue.$store.state.userInfo.user.appid &&
        myVue.$store.state.userInfo.user.openid &&
        myVue.$store.state.userInfo.user.passport
      ) {
        link += `&j=${encodeURIComponent(
          JSON.stringify({
            appid: myVue.$store.state.userInfo.user.appid,
            openid: myVue.$store.state.userInfo.user.openid,
            passport: myVue.$store.state.userInfo.user.passport
          })
        )}`;
      }
    }
    this.openUrl(link);
  },
  openUrl(url, mpRouteType) {
    if (myVue.$store.state.isInMiniProgram) {
      wx.miniProgram.postMessage({ data: { url: url } });
      url = url.replace("http:", "https:");
    } else {
      // 现在在线售楼中心都支持https了，不用再做这个处理了
      // url = url.replace("https:", "http:");
    }
    if (myVue.global.isLoc) {
      url = url.replace("https:", "http:");
    }
    if (myVue.$store.state.isInMiniProgram && this.checkIsHuafa()) {
      // 在小程序中且是华发
      // 校验是否在业务返回内
      let isIN = false;
      global_.MP_DOMAIN.BUSINESS_HUAFA.forEach(item => {
        if (url.indexOf(item) > -1) {
          isIN = true;
        }
      });
      if (isIN == false) {
        return;
      }
      if (isIN) {
        // 在小程序里打开
        if (mpRouteType) {
          wx.miniProgram[mpRouteType]({
            url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
          });
        } else {
          wx.miniProgram.navigateTo({
            url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
          });
        }
      }
    } else if (myVue.$store.state.isInMiniProgram && !this.checkIsHaveOldMp()) {
      if (mpRouteType) {
        wx.miniProgram[mpRouteType]({
          url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
        });
      } else {
        wx.miniProgram.navigateTo({
          url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
        });
      }
    } else {
      location.href = url;
    }
  },
  getUrl2(url, mpRouteType) {
    if (myVue.$store.state.isInMiniProgram) {
      wx.miniProgram.postMessage({ data: { url: url } });
      url = url.replace("http:", "https:");
    } else {
      // 现在在线售楼中心都支持https了，不用再做这个处理了
      // url = url.replace("https:", "http:");
    }
    if (myVue.global.isLoc) {
      url = url.replace("https:", "http:");
    }
    if (myVue.$store.state.isInMiniProgram && this.checkIsHuafa()) {
      // 在小程序中且是华发
      // 校验是否在业务返回内
      let isIN = false;
      global_.MP_DOMAIN.BUSINESS_HUAFA.forEach(item => {
        if (url.indexOf(item) > -1) {
          isIN = true;
        }
      });
      if (isIN == false) {
        return;
      }
      if (isIN) {
        // 在小程序里打开
        if (mpRouteType) {
          wx.miniProgram[mpRouteType]({
            url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
          });
        } else {
          wx.miniProgram.navigateTo({
            url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
          });
        }
      }
    } else if (myVue.$store.state.isInMiniProgram && !this.checkIsHaveOldMp()) {
      if (mpRouteType) {
        wx.miniProgram[mpRouteType]({
          url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
        });
      } else {
        wx.miniProgram.navigateTo({
          url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
        });
      }
    } else {
      // location.href = url;
      return url.split("?")[1];
    }
  },
  openShqcWebChat(receiveropenid, receivernickname) {
    if (this.checkIsTest() || this.checkIsAlej()) {
      this.openChatDialog(receiveropenid);
    } else {
      let url = `${location.protocol}//${location.host}`;
      if (myVue.global.isLoc) {
        url = "http://localhost:2000/gong/yuanquan/shqc-web";
      }
      url += `/newcode/src/chat_room.html?entry=zxslzx&openid=${myVue.$store.state.userInfo.user.openid
        }&passport=${myVue.$store.state.userInfo.user.passport
        }&receiveropenid=${receiveropenid}&nickname=${encodeURIComponent(
          receivernickname
        )}`;
      if (myVue.$store.state.pageInfo) {
        url = this.addUrlParamFromObj(url, {
          pageid: myVue.$store.state.pageInfo.PageId,
          projectid: myVue.$store.state.pageInfo.Pid
        });
      }
      this.openUrl(url);
    }
  },
  openShqcWebChat2(receiveropenid, receivernickname) {
    // if (this.checkIsTest() || this.checkIsAlej()) {
    //   this.openChatDialog(receiveropenid);
    // } else {
    let url = `${location.protocol}//${location.host}`;
    if (myVue.global.isLoc) {
      url = "http://localhost:2000/gong/yuanquan/shqc-web";
    }
    url += `/newcode/src/chat_room.html?entry=zxslzx&openid=${myVue.$store.state.userInfo.user.openid
      }&passport=${myVue.$store.state.userInfo.user.passport
      }&receiveropenid=${receiveropenid}&nickname=${encodeURIComponent(
        receivernickname
      )}`;
    if (myVue.$store.state.pageInfo) {
      url = this.addUrlParamFromObj(url, {
        pageid: myVue.$store.state.pageInfo.PageId,
        projectid: myVue.$store.state.pageInfo.Pid
      });
    }
    this.openUrl(url);
    // }
  },
  /**
   * 获取url不含参数，不传就获取当前页面的
   */
  getCurrentUrl(url) {
    let tmpStr = "";
    if (url) {
      tmpStr = url.split("?");
    } else {
      tmpStr = location.href.split("?");
    }
    if (tmpStr.length > 0) {
      return tmpStr[0];
    }
    return "";
  },
  /**
   * 从url上获取参数
   */
  getParamFromUrl(url) {
    let tmpObj = {};
    let tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      let urlParam = tmpArr[1];
      let tmpArr1 = urlParam.split("&");
      tmpArr1 = tmpArr1.map(function (e) {
        tmpObj[e.split("=")[0]] = e.split("=")[1];
      });
    }
    return tmpObj;
  },
  /**
   * 对象转换url参数
   * 遇到属性值为空或0就不拼接
   */
  objToUrlParam(obj) {
    let urlParam = "";
    Object.keys(obj).forEach(function (e) {
      if (obj[e]) {
        urlParam += `${e}=${obj[e]}&`;
      }
    });
    if (urlParam.length > 0) {
      urlParam = urlParam.substring(0, urlParam.length - 1);
    }
    return urlParam;
  },
  // 给url添加参数 通过对象
  addUrlParamFromObj(url, obj) {
    if (url.indexOf("?") > -1) {
      url += "&" + this.objToUrlParam(obj);
    } else {
      url += "?" + this.objToUrlParam(obj);
    }
    return url;
  },
  /*
   * @Description: 获取不带参数的URL
   * @param:
   * @return:
   */
  getUrlRemoveParams(url) {
    url = url || location.href;
    if (url.indexOf("?") != -1) {
      url = url.split("?")[0];
      return url;
    }
    return url;
  },
  /**
   * 获取域名根据链接
   * @param {*} url
   */
  getHostFromUrl(url) {
    let domain = url.split("/");
    let host = "";
    if (domain[2] && (this.isWebUrl(domain[2]) || myVue.global.isLoc)) {
      host = domain[2];
    }
    return host;
  },
  // 验证手机号码合法性
  isMobile: function (mobile) {
    return /^1+\d{10}$/.test(String(mobile).replace(/^0+/g, ""));
  },
  isGATMobile: function (mobile) {
    return /^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/.test(
      String(mobile).replace(/^0+/g, "")
    );
  },
  formatMoney: function (n) {
    if (n) {
      if (parseFloat(n) == 0) {
        return "0.00";
      }
      n = parseFloat(n).toFixed(2);
      let num = n.toString();
      let decimals = "";
      // 判断是否有小数
      num.indexOf(".") > -1 ? (decimals = num.split(".")[1]) : decimals;
      let len = num.length;
      if (len <= 3) {
        return num;
      } else {
        let temp = "";
        let remainder = len % 3;
        decimals ? (temp = "." + decimals) : temp;
        if (remainder > 0) {
          // 不是3的整数倍
          return (
            num.slice(0, remainder) +
            "," +
            num
              .slice(remainder, len)
              .match(/\d{3}/g)
              .join(",") +
            temp
          );
        } else {
          // 是3的整数倍
          return (
            num
              .slice(0, len)
              .match(/\d{3}/g)
              .join(",") + temp
          );
        }
      }
    } else {
      return "";
    }
  },
  /**
   * 是否是网址
   * @param {*} url
   */
  isWebUrl(url) {
    return /^(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/.test(
      url
    );
  },
  /**
   * 是否是图片链接
   */
  isImgUrl(url) {
    return /^\S+\.(jpg|jpeg|png)$/.test(url);
  },
  formatDate: function (secs, type = 0) {
    //type是可选参数，因为json中时间的格式是year-month-date,不能识别XX年XX月XX日
    var t = new Date(secs);
    var year = t.getFullYear();
    var month = t.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var date = t.getDate();
    if (date < 10) {
      date = "0" + date;
    }
    //  var hour = t.getHours()
    //  if(hour < 10){ hour = '0' + hour }
    // var minute = t.getMinutes()
    // if(minute < 10){ minute = '0' + minute }
    //  var second = t.getSeconds()
    //  if(second < 10){ second = '0' + second }
    if (type == 0) {
      return year + "年" + month + "月" + date + "日";
    } else {
      return year + "-" + month + "-" + date;
    }
  },
  getTime: function (time) {
    let date = new Date(time);
    let m = date.getMonth() + 1;
    m <= 9 ? (m = "0" + m) : m;
    let d = date.getDate();
    d <= 9 ? (d = "0" + d) : d;
    return date.getFullYear() + "-" + m + "-" + d;
  },
  getFullTime: function (time) {
    let date = new Date(time);
    let m = date.getMonth() + 1;
    m <= 9 ? (m = "0" + m) : m;
    let d = date.getDate();
    d <= 9 ? (d = "0" + d) : d;
    let h = date.getHours();
    h <= 9 ? (h = "0" + h) : h;
    let m2 = date.getMinutes();
    m2 <= 9 ? (m2 = "0" + m2) : m2;
    let s = date.getSeconds();
    s <= 9 ? (s = "0" + s) : s;
    return (
      date.getFullYear() + "-" + m + "-" + d + " " + h + ":" + m2 + ":" + s
    );
  },
  getFullTimeHm2: function (time) {
    let date = new Date(time);
    let h = date.getHours();
    h <= 9 ? (h = "0" + h) : h;
    let m2 = date.getMinutes();
    m2 <= 9 ? (m2 = "0" + m2) : m2;
    return h + ":" + m2;
  },
  getFullTimeHm: function (time) {
    let date = new Date(time);
    let m = date.getMonth() + 1;
    // m <= 9 ? (m = "0" + m) : m;
    let d = date.getDate();
    // d <= 9 ? (d = "0" + d) : d;
    let h = date.getHours();
    h <= 9 ? (h = "0" + h) : h;
    let m2 = date.getMinutes();
    m2 <= 9 ? (m2 = "0" + m2) : m2;
    return date.getFullYear() + "年" + m + "月" + d + "日 " + h + ":" + m2;
  },
  formatTime4(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    return month + "月" + day + "日";
  },
  formatTime5(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    return year + "年" + month + "月" + day + "日";
  },
  initCookies: function (query) {
    // let query = Qs.parse(location.search.substring(1));
    let baseUrl = `${location.protocol}//${location.host}${location.pathname}`;
    if (query.j) {
      let params = JSON.parse(query.j);
      global_.paramKeys.forEach(name => {
        if (name in params) {
          Cookies.set(name, params[name], { expires: 30 });
        }
      });
      // delete query.j;
      // setTimeout(function () {
      //   if (Qs.stringify(query)) {
      //     window.location.href = `${baseUrl}?${Qs.stringify(query)}`;
      //   } else {
      //     window.location.href = baseUrl;
      //   }
      // }, 100);
    } else if (query.cmd && query.cmd === "clean") {
      global_.paramKeys.forEach(name => {
        Cookies.remove(name);
      });
      delete query.cmd;
      let url = Qs.stringify(query)
        ? `${baseUrl}?${Qs.stringify(query)}`
        : baseUrl;
      localStorage.clear();
      window.location.href = url;
    } else if (query.fake) {
      global_.paramKeys.forEach(name => {
        if (global_.FAKE_DATA[query.fake]) {
          Cookies.set(name, global_.FAKE_DATA[query.fake][name], {
            expires: 30
          });
        }
      });
    }
  },
  needsAuth: function (type, callback) {
    if (Cookies.get("openid") && Cookies.get("passport")) {
      if (Cookies.get("passport") === "null") {
        global_.paramKeys.forEach(name => {
          Cookies.remove(name);
        });
        window.location.reload();
      } else {
        callback();
      }
    } else {
      let query = Qs.parse(location.search.substring(1));
      delete query.cmd;
      delete query.j;
      let url = `${location.protocol}//${location.host}${location.pathname
        }?${Qs.stringify(query)}`;
      Cookies.set("appid", global_.APPID, { expires: 30 });
      this.parseOauthUrl(url, type);
    }
  },
  parseOauthUrl: function (url, type) {
    // alert(type)
    let redirectUrl = url || location.href;
    let scope = type == 1 ? "snsapi_userinfo" : "snsapi_base";
    // alert(scope)
    Cookies.set(`${global_.APPID}-oauth-state`, redirectUrl, { expires: 30 });
    let auth_url = global_.OAUTH_URL.replace(
      /\{appid\}/g,
      encodeURIComponent(global_.APPID)
    )
      .replace(
        "{state}",
        encodeURIComponent(
          `${location.protocol}//${location.host}${global_.GLOBAL_BASE_PATH
          }/redirect`
        )
      )
      .replace("{scope}", scope);
    // alert(auth_url);
    console.log(auth_url);
    // https://qmyx.ttrushi.com/qc-webapp/wxapi.do?appid=&scope=&wxauthcburl=
    window.location.href = auth_url;
    // window.location.href = `${global_.API_URL}?appid=${global_.APPID}&scope=${scope}&wxauthcburl=${encodeURIComponent(redirectUrl)}`;
  },
  textMatch: function (word1, word2, rate) {
    // try {
    let command = word1
      .toString()
      .trim()
      .replace(/[^\u4e00-\u9fa5a-zA-Z\d]+/g, "");
    let word = word2
      .toString()
      .trim()
      .replace(/[^\u4e00-\u9fa5a-zA-Z\d]+/g, "");
    if (command.trim().length != word.trim().length) {
      return false;
    } else {
      let rightCount = 0;
      for (let i = 0; i < command.length; i++) {
        if (word[i] == command[i]) {
          rightCount += 1;
        }
      }
      return rightCount / command.length > rate;
    }
    // } catch (e) {
    // }
  },
  // 身份证验证
  idCardValid: function (id) {
    // 1 "验证通过!", 0 //校验不通过
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if (!format.test(id)) {
      return false;
    }
    //区位码校验
    //出生年月日校验   前正则限制起始年份为1900;
    var year = id.substr(6, 4), //身份证年
      month = id.substr(10, 2), //身份证月
      date = id.substr(12, 2), //身份证日
      time = Date.parse(month + "-" + date + "-" + year), //身份证日期时间戳date
      now_time = Date.parse(new Date()), //当前时间戳
      dates = new Date(year, month, 0).getDate(); //身份证当月天数
    if (time > now_time || date > dates) {
      return false;
    }
    //校验码判断
    var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
    var b = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"); //校验码对照表
    var id_array = id.split("");
    var sum = 0;
    for (var k = 0; k < 17; k++) {
      sum += parseInt(id_array[k]) * parseInt(c[k]);
    }
    if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
      return false;
    }
    return true;
  },
  isHKCard(card) {
    // 港澳居民来往内地通行证
    // 规则： H/M + 10位或6位数字
    // 样本： H1234567890
    var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
    if (reg.test(card) === false) {
      return false;
    } else {
      return true;
    }
  },
  browser: {
    info: navigator.appVersion,
    versions: (function () {
      let u = navigator.userAgent;
      return {
        trident: u.indexOf("Trident") > -1,
        presto: u.indexOf("Presto") > -1,
        webKit: u.indexOf("AppleWebKit") > -1,
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1,
        iPad: u.indexOf("iPad") > -1,
        webApp: u.indexOf("Safari") == -1,
        wx: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
        wxwork: u.match(/wxwork/i) == 'wxwork'
      };
    })()
  },
  getSystemInfo: function () {
    return {
      height: document.documentElement.clientHeight,
      width: document.documentElement.clientWidth
    };
  },
  setTimeStorage(key, value, days) {
    var item = {
      data: value,
      endTime: new Date().getTime() + days * 24 * 3600 * 1000
    };
    localStorage.setItem(key, JSON.stringify(item));
  },
  getTimeStorage(key) {
    var val = localStorage.getItem(key);
    if (!val) return null;
    val = JSON.parse(val);
    if (new Date().getTime() > val.endTime) {
      val = null;
      localStorage.removeItem(key);
      return null;
    }
    return val.data;
  },
  /**
   *
   * @param {*} n
   * @param {*} v
   * @param {*} addParamObj 附加参数 过期时间用这样的格式{ expires: 60 * 60 * 1 } 单位秒
   */
  setStorage(n, v, addParamObj) {
    if (window.localStorage) {
      if (addParamObj) {
        let newV = {
          data: JSON.stringify(v)
        };
        if (addParamObj.expires) {
          newV.expires = new Date().getTime() + addParamObj.expires * 1000;
        }
        localStorage.setItem(n, JSON.stringify(newV));
      } else {
        localStorage.setItem(n, JSON.stringify(v));
      }
    } else {
      if (addParamObj) {
        Cookies.set(n, v, addParamObj);
      } else {
        Cookies.set(n, v);
      }
    }
  },
  getStorage(n) {
    if (window.localStorage) {
      var val = localStorage.getItem(n);
      if (!val) return null;
      val = JSON.parse(val);
      if (typeof val == "object") {
        if (val.expires) {
          if (new Date().getTime() > val.expires) {
            val = null;
            this.removeStorage(n);
          }
        }
        if (val != null) {
          val = JSON.parse(val.data);
        }
      }
      return val;
    } else {
      return Cookies.get(n);
    }
  },
  removeStorage(n) {
    if (window.localStorage) {
      localStorage.removeItem(n);
    } else {
      Cookies.remove(n);
    }
  },
  mixin(obj1, obj2) {
    Object.keys(obj2).forEach(k => {
      obj1[k] = obj2[k];
    });
    return obj1;
  },
  getGuid: function () {
    var tmpGuid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      tmpGuid += n;
      if (i == 8 || i == 12 || i == 16 || i == 20) tmpGuid += "";
    }
    return tmpGuid;
  },
  /**
   * url参数完整性校验
   * 例如：
   * objNeed {id:1,name:'xx'}
   * objActual 实际的url值
   * @param {*} objNeed
   * @param {*} objActual
   */
  queryCheck: function (objNeed, objActual) {
    let checkResult = true;
    let msg = "";
    if (objNeed) {
      Object.keys(objNeed).forEach(key => {
        if (!objActual.hasOwnProperty(key)) {
          checkResult = false;
          msg += "缺少url参数：" + key + "(" + objNeed[key] + ")；";
        }
      });
    }
    if (msg != "") {
      if (objNeed.id && objNeed.psn) {
        this.messageBox(`链接错误（-12）${location.href}`);
      } else {
        MessageBox.alert(msg);
      }
    }
    return checkResult;
  },

  /**
   * 获取是否在微信小程序的环境下 ismp undefined
   */
  getIsInMiniProgram(currentIsInMiniProgram) {
    let that = this;
    return new Promise(function (resolve, reject) {
      if (currentIsInMiniProgram == undefined) {
        if (global_.isLoc && global_.isMp) {
          resolve(true); //模拟小程序里面分享
        }
        if (that.browser.versions.wx) {
          wx.miniProgram.getEnv(function (res) {
            resolve(res.miniprogram);
          });
        } else {
          resolve(false);
        }
      } else {
        resolve(currentIsInMiniProgram);
      }
    });
  },

  /*
   * @Description: 设置创建页面的分享
   * @param: 页面信息。含有分享的信息
   * @param: 分享传播信息。
   * @param: 是否不重新初始化wxjssdk。当为true时候，用于仅仅把分享信息设置到global，场景是在小程序内嵌的时候。
   * @return:
   */
  setFoundShare(pageInfo, shareSpreadInfo, isNotInitWxsdk, queryStr) {
    global_.SHARE_TITLE = pageInfo.BrowserTabTitle;
    if (pageInfo.WxShare && pageInfo.WxShare.Title) {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.Description) {
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.FilePath) {
      global_.SHARE_IMG_URL = pageInfo.WxShare.FilePath;
    }
    let shareLink = this.getUrlRemoveParams();
    shareLink += `?id=${shareSpreadInfo.id}&psn=${shareSpreadInfo.psn}`;
    shareLink += `&refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    if (queryStr) {
      shareLink += queryStr;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setFoundShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: shareLink
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },
  /**
   * 比setFoundShare多了自定义标题和描述
   * @param {*} title
   * @param {*} desc
   * @param {*} pageInfo
   * @param {*} shareSpreadInfo
   * @param {*} isNotInitWxsdk
   * @param {*} queryStr
   */
  setFoundShare2(
    title,
    desc,
    pageInfo,
    shareSpreadInfo,
    isNotInitWxsdk,
    queryStr,
    shareImg
  ) {
    global_.SHARE_TITLE = pageInfo.BrowserTabTitle;
    if (pageInfo.WxShare && pageInfo.WxShare.Title) {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.Description) {
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    if (shareImg) {
      global_.SHARE_IMG_URL = shareImg;
    } else if (pageInfo.WxShare && pageInfo.WxShare.FilePath) {
      global_.SHARE_IMG_URL = pageInfo.WxShare.FilePath;
    }
    if (title) {
      global_.SHARE_TITLE = title;
    }
    if (desc) {
      global_.SHARE_DESC = desc;
    }

    let shareLink = this.getUrlRemoveParams();
    shareLink += `?id=${shareSpreadInfo.id}&psn=${shareSpreadInfo.psn}`;
    shareLink += `&refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    if (queryStr) {
      shareLink += queryStr;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setFoundShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: shareLink
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },

  setFoundShareT7(
    title,
    desc,
    pageInfo,
    shareSpreadInfo,
    isNotInitWxsdk,
    queryStr,
    shareImg
  ) {
    global_.SHARE_TITLE = pageInfo.BrowserTabTitle;
    if (pageInfo.WxShare && pageInfo.WxShare.Title) {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.Description) {
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    if (shareImg) {
      global_.SHARE_IMG_URL = shareImg;
    } else if (pageInfo.WxShare && pageInfo.WxShare.FilePath) {
      global_.SHARE_IMG_URL = pageInfo.WxShare.FilePath;
      if (this.checkIsShlfsj()) {
        global_.SHARE_IMG_URL = `https://assets.rurushishi.com/yq-rs-make/lfs/share_lfs.jpg`;
      }
    }
    if (title) {
      global_.SHARE_TITLE = title;
    }
    if (desc) {
      global_.SHARE_DESC = desc;
    }

    let shareLink = `${location.protocol}//${location.host}/h5/t7`;
    shareLink += `?id=${shareSpreadInfo.id}&psn=${shareSpreadInfo.psn}`;
    shareLink += `&refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    if (queryStr) {
      shareLink += queryStr;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setFoundShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: shareLink
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },

  /**
   * 比setFoundShare多了自定义标题和描述,并且固定分享成t9
   * @param {*} title
   * @param {*} desc
   * @param {*} pageInfo
   * @param {*} shareSpreadInfo
   * @param {*} isNotInitWxsdk
   * @param {*} queryStr
   */
  setFoundShareT9(
    title,
    desc,
    pageInfo,
    shareSpreadInfo,
    isNotInitWxsdk,
    queryStr
  ) {
    global_.SHARE_TITLE = pageInfo.BrowserTabTitle;
    if (pageInfo.WxShare && pageInfo.WxShare.Title) {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.Description) {
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.FilePath) {
      global_.SHARE_IMG_URL = pageInfo.WxShare.FilePath;
    }
    if (this.checkIsShlfsj()) {
      global_.SHARE_IMG_URL = `https://assets.rurushishi.com/yq-rs-make/lfs/share_lfs.jpg`;
    }
    if (title) {
      global_.SHARE_TITLE = title;
    }
    if (desc) {
      global_.SHARE_DESC = desc;
    }
    if (global_.SUBDOMAIN == "taxyzhc") {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    let shareLink = `${location.protocol}//${location.host}/h5/t9`;
    shareLink += `?id=${shareSpreadInfo.id}&psn=${shareSpreadInfo.psn}`;
    shareLink += `&refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    if (queryStr) {
      shareLink += queryStr;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setFoundShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: shareLink
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },

  setFoundShareCustomPageName(
    title,
    desc,
    pageInfo,
    shareSpreadInfo,
    isNotInitWxsdk,
    queryStr,
    shareImg,
    pathname
  ) {
    global_.SHARE_TITLE = pageInfo.BrowserTabTitle;
    if (pageInfo.WxShare && pageInfo.WxShare.Title) {
      global_.SHARE_TITLE = pageInfo.WxShare.Title;
    }
    if (pageInfo.WxShare && pageInfo.WxShare.Description) {
      global_.SHARE_DESC = pageInfo.WxShare.Description;
    }
    if (shareImg) {
      global_.SHARE_IMG_URL = shareImg;
    } else if (pageInfo.WxShare && pageInfo.WxShare.FilePath) {
      global_.SHARE_IMG_URL = pageInfo.WxShare.FilePath;
    }
    if (title) {
      global_.SHARE_TITLE = title;
    }
    if (desc) {
      global_.SHARE_DESC = desc;
    }
    let shareLink = `${location.protocol}//${location.host}/h5/${pathname}`;
    shareLink += `?id=${shareSpreadInfo.id}&psn=${shareSpreadInfo.psn}`;
    shareLink += `&refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    if (queryStr) {
      shareLink += queryStr;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setFoundShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: shareLink
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },

  setVcardShare(that, shareSpreadInfo, isNotInitWxsdk) {
    global_.SHARE_TITLE = `我是${that.cardInfo.Ui.Name}，欢迎您随时联系`;
    global_.SHARE_DESC = `手机号：${that.cardInfo.User.Phone} 微信号：${that.cardInfo.User.Wechat
      }`;
    global_.SHARE_IMG_URL = that.cardInfo.Ui.HeadImg;
    let shareLink = this.getUrlRemoveParams();
    shareLink += `?refereeopenid=${shareSpreadInfo.refereeopenid}`;
    if (shareSpreadInfo.rscuid) {
      shareLink += `&rscuid=${shareSpreadInfo.rscuid}`;
    }
    global_.SHARE_LINK = shareLink;
    console.log("setVcardShare", shareLink);
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },

  setLiveShare(title, desc, shareSpreadInfo, isNotInitWxsdk) {
    if (title) {
      global_.SHARE_TITLE = title;
    }
    if (desc) {
      global_.SHARE_DESC = desc;
    }
    let shareLink = `${location.protocol}//${location.host
      }/h5/live/liveroominfo`;
    shareLink = this.addUrlParamFromObj(shareLink, shareSpreadInfo);
    global_.SHARE_IMG_URL = shareSpreadInfo.shareImg;
    global_.SHARE_LINK = shareLink;
    console.log("setLiveShare", {
      title: global_.SHARE_TITLE,
      desc: global_.SHARE_DESC,
      shareLink: global_.SHARE_LINK
    });
    if (isNotInitWxsdk && isNotInitWxsdk == true) {
    } else {
      wxsdk.init();
    }
  },
  /*
   * @Description: 格式化用户小程序信息，统一姓名和头像
   * @param:
   * @return:
   */
  formatHdkUserInfo(userInfo) {
    let tmpUser = userInfo;
    tmpUser.Ui = {};
    tmpUser.Ui.Name = tmpUser.User.Name || tmpUser.Wxuser.NickName;
    tmpUser.Ui.HeadImg = tmpUser.User.PhotoUrl || tmpUser.Wxuser.AvatarUrl;
    // 是否已注册
    if (tmpUser.User.Name && tmpUser.User.Phone) {
      tmpUser.isRegister = true;
    } else {
      tmpUser.isRegister = false;
    }
    return tmpUser;
  },
  /**
   * 等待指定的state有值后回调
   * @param {*} that
   * @param {*} mapStateNames 要校验的state名字
   */
  checkMapStateCallback(that, mapStateNames) {
    return new Promise(function (resolve, reject) {
      let tmpInterval20190622 = setInterval(() => {
        let b = true;
        mapStateNames.forEach(function (e) {
          if (!that[e]) {
            b = false;
          }
        });
        if (b == true) {
          resolve();
          clearInterval(tmpInterval20190622);
        }
      }, 1);
    });
  },
  /**
   * 1、分享当前页面，带默认传播信息
   * 未使用
   * @param {*} that vue实例
   */
  navigateToShareMomentsCurrentPage: function (that) {
    // 组合小程序webview链接
    let webviewUrl = this.getCurrentUrl();
    let currentUrlParam = this.getParamFromUrl(location.href);
    currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
    currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
    webviewUrl += "?" + this.objToUrlParam(currentUrlParam);

    // 组合朋友圈打开链接
    let wxtitle = "",
      wxdesc = "",
      wxsmallpic = "",
      wxurl = "";
    let sendMessageTitle = "",
      sendMessageImg = "",
      btnName = "";
    if (that.userInfo && that.userInfo.user && that.userInfo.user.state == 1) {
      // 已关注
      wxtitle = sendMessageTitle = that.global.SHARE_TITLE;
      wxdesc = that.global.SHARE_DESC;
      wxsmallpic = that.global.SHARE_IMG_URL;
      wxurl = webviewUrl;
      if (that.$pageType == that.$enumPageType.t3) {
        sendMessageImg =
          "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon3.png";
      } else if (that.$pageType == that.$enumPageType.vcard) {
        sendMessageImg =
          "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon4.png";
      }
      btnName = "领取链接";
    } else {
      // 未关注
      wxtitle = sendMessageTitle = "关注很多客公众号，解锁更多AI获客神器功能";
      wxdesc = "18位您的朋友已经关注了";
      wxsmallpic =
        "https://assets.rurushishi.com/yq-rs-make/other/henduoke_icon.png";
      // sendMessageImg = "https://assets.wxmp.ruthus.com/henduoke/share_moments/icon5.png";
      sendMessageImg =
        "https://assets.wxmp.ruthus.com/henduoke/share_moments/icon3.png";
      btnName = "领取链接";
      let fist_push_text = "";
      if (that.$pageType == that.$enumPageType.t3) {
        // 这是您的专属获客文案内容，点开分享就可以轻松获客了
        // fist_push_text = `这是您的专属获客文章《${that.pageInfo.BrowserTabTitle}》已生成，<a href="%s">点开分享就可以轻松获客了</a>`;
        fist_push_text = `您的专属获客文章已生成，<a href="%s">点开分享就可以轻松获客了</a>`;
        fist_push_text = fist_push_text.replace(
          "%s",
          decodeURIComponent(webviewUrl)
        );
        // fist_push_text="欢迎关注！";
      } else if (that.$pageType == that.$enumPageType.vcard) {
        // 这是您的专属智能名片，点开分享就可以轻松获客了
        fist_push_text = `您的专属智能名片已生成，<a href="%s">点开分享就可以轻松获客了</a>`;
        fist_push_text = fist_push_text.replace(
          "%s",
          decodeURIComponent(webviewUrl)
        );
      }
      let h5url = `https://${location.host
        }/h5/hdk/comm_show_img?type=get_hdk_qrcode&title=${encodeURIComponent(
          "扫码关注获取链接"
        )}&intro=${encodeURIComponent(wxtitle)}&appid=${encodeURIComponent(
          that.userInfo.user && that.userInfo.user.appid
        )}&url=${encodeURIComponent(
          webviewUrl
        )}&fist_push_text=${encodeURIComponent(fist_push_text)}`;
      wxurl = h5url;
    }
    // 组合发到客服消息的小程序链接,前面已经把分享信息设置到了 global_ 直接取用
    let sendMessagePath = `/pages/webview/common/common?cuid=${that.cardInfo.User.Id
      }&url=${encodeURIComponent(
        webviewUrl
      )}&action=h5share&wxtitle=${encodeURIComponent(
        wxtitle
      )}&wxdesc=${encodeURIComponent(wxdesc)}&wxurl=${encodeURIComponent(
        wxurl
      )}&wxsmallpic=${encodeURIComponent(wxsmallpic)}`;

    // 导航到小程序中转页
    wx.miniProgram.navigateTo({
      url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
        btnName
      )}&sendMessageTitle=${encodeURIComponent(
        sendMessageTitle
      )}&sendMessageImg=${encodeURIComponent(
        sendMessageImg
      )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
    });
  },
  /**
   * 2、分享指定链接，可设置标题、描述、小图。如不设置就用默认传播信息
   * 未使用
   * @param {*} that vue实例
   * @param {Object} shareObj link,title,desc,img
   */
  navigateToShareMomentsCustomPage: function (that, shareObj) {
    if (!shareObj) {
      shareObj = {};
    }
    if (!shareObj.link) {
      alert("navigateToShareMomentsCustomPage shareObj link 不能为空");
      return;
    }
    if (!shareObj.title) {
      shareObj.title = that.global.SHARE_TITLE;
    }
    if (!shareObj.desc) {
      shareObj.desc = that.global.SHARE_DESC;
    }
    if (!shareObj.img) {
      shareObj.img = that.global.SHARE_IMG_URL;
    }

    // 组合小程序webview链接
    let webviewUrl = this.getCurrentUrl(shareObj.link);
    let currentUrlParam = this.getParamFromUrl(shareObj.link);
    currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
    currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
    webviewUrl += "?" + this.objToUrlParam(currentUrlParam);

    // 组合朋友圈打开链接
    let wxurl = "",
      btnName = "";
    if (that.userInfo && that.userInfo.user && that.userInfo.user.state == 1) {
      // 已关注
      wxurl = webviewUrl;
      btnName = "领取链接";
    } else {
      // 未关注
      btnName = "领取链接";
      let fist_push_text = "";
      fist_push_text = `您的《${decodeURIComponent(
        shareObj.title
      )}》已生成，<a href="%s">点击分享到朋友圈</a>`;
      fist_push_text = fist_push_text.replace(
        "%s",
        decodeURIComponent(webviewUrl)
      );
      let h5url = `https://${location.host
        }/h5/hdk/comm_show_img?type=get_hdk_qrcode&title=${encodeURIComponent(
          "扫码获取链接"
        )}&appid=${encodeURIComponent(
          that.userInfo.user && that.userInfo.user.appid
        )}&url=${encodeURIComponent(
          webviewUrl
        )}&fist_push_text=${encodeURIComponent(fist_push_text)}`;
      wxurl = h5url;
    }
    // 组合发到客服消息的小程序链接,前面已经把分享信息设置到了 global_ 直接取用
    let sendMessagePath = `/pages/webview/common/common?url=${encodeURIComponent(
      webviewUrl
    )}&action=h5share&wxtitle=${encodeURIComponent(
      that.global.SHARE_TITLE
    )}&wxdesc=${encodeURIComponent(
      that.global.SHARE_DESC
    )}&wxurl=${encodeURIComponent(wxurl)}&wxsmallpic=${encodeURIComponent(
      that.global.SHARE_IMG_URL
    )}`;

    // 跳转到小程序中转页
    wx.miniProgram.navigateTo({
      url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
        btnName
      )}&sendMessageTitle=${encodeURIComponent(
        that.global.SHARE_TITLE
      )}&sendMessageImg=${encodeURIComponent(
        that.global.SHARE_IMG_URL
      )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
    });
  },

  /**
   * 3、分享图片链接，可设置标题、描述、小图。如不设置就用默认传播信息
   * @param {*} that vue实例
   * @param {Object} shareObj link,title,desc,img
   * 目前仅仅在获取微信二维码的时候用到
   */
  navigateToShareMomentsPageContainImg: function (that, shareObj, imgUrl) {
    if (!shareObj) {
      shareObj = {};
    }
    if (!shareObj.link) {
      shareObj.link = that.global.SHARE_LINK;
    }
    if (!shareObj.title) {
      shareObj.title = that.global.SHARE_TITLE;
    }
    if (!shareObj.desc) {
      shareObj.desc = that.global.SHARE_DESC;
    }
    if (!shareObj.img) {
      shareObj.img = that.global.SHARE_IMG_URL;
    }
    if (!shareObj.sendMessageTitle) {
      shareObj.sendMessageTitle = that.global.SHARE_TITLE;
    }
    if (!shareObj.sendMessageImg) {
      shareObj.sendMessageImg = that.global.SHARE_IMG_URL;
    }
    if (!shareObj.intro) {
      shareObj.intro = "长按扫码关注";
    }

    // 组合小程序webview链接
    let webviewUrl = this.getCurrentUrl(shareObj.link);
    let currentUrlParam = this.getParamFromUrl(shareObj.link);
    currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
    currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
    webviewUrl += "?" + this.objToUrlParam(currentUrlParam);

    // 组合朋友圈打开链接
    let wxurl = `https://${location.host
      }/h5/hdk/comm_show_img?type=direct_show&title=${encodeURIComponent(
        "扫码关注"
      )}&intro=${encodeURIComponent(shareObj.intro)}&url=${encodeURIComponent(
        imgUrl
      )}`;

    // 组合发到客服消息的小程序链接,前面已经把分享信息设置到了 global_ 直接取用
    let sendMessagePath = `/pages/webview/common/common?url=${encodeURIComponent(
      webviewUrl
    )}&action=h5share&wxtitle=${encodeURIComponent(
      shareObj.title
    )}&wxdesc=${encodeURIComponent(shareObj.desc)}&wxurl=${encodeURIComponent(
      wxurl
    )}&wxsmallpic=${encodeURIComponent(shareObj.img)}`;

    // 跳转到小程序中转页
    wx.miniProgram.navigateTo({
      url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
        "领取链接"
      )}&sendMessageTitle=${encodeURIComponent(
        shareObj.sendMessageTitle
      )}&sendMessageImg=${encodeURIComponent(
        shareObj.sendMessageImg
      )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
    });
  },
  /**
   * 4、通用打开分享中转页
   * @param {*} that vue实例 非必填
   * @param {Object} shareObj sendMessageTitle,sendMessageImg,sendMessagePath
   */
  navigateToShareMomentsPage: function (that, addObj) {
    // 跳转到小程序中转页
    wx.miniProgram.navigateTo({
      url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
        "领取二维码"
      )}&sendMessageTitle=${encodeURIComponent(
        addObj.sendMessageTitle
      )}&sendMessageImg=${encodeURIComponent(
        addObj.sendMessageImg
      )}&sendMessagePath=${encodeURIComponent(addObj.sendMessagePath)}`
    });
  },
  /**
   * 5、分享当前页面，带默认传播信息，如果未关注回复二维码
   * @param {*} that vue实例
   */
  navigateToShareMomentsCurrentPageNoFollowReturnQrCode: function (that) {
    // 组合小程序webview链接
    let webviewUrl = this.getCurrentUrl();
    let currentUrlParam = this.getParamFromUrl(location.href);
    currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
    currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
    webviewUrl += "?" + this.objToUrlParam(currentUrlParam);

    // 组合朋友圈打开链接
    let wxtitle = "",
      wxdesc = "",
      wxsmallpic = "",
      wxurl = "";
    let sendMessagePath = "",
      sendMessageTitle = "",
      sendMessageImg = "",
      btnName = "",
      action = "h5share",
      pageType = "";
    if (that.userInfo && that.userInfo.user && that.userInfo.user.state == 1) {
      // 已关注
      wxtitle = sendMessageTitle = that.global.SHARE_TITLE;
      wxdesc = that.global.SHARE_DESC;
      wxsmallpic = that.global.SHARE_IMG_URL;
      wxurl = webviewUrl;
      if (
        that.$pageType == that.$enumPageType.t3 ||
        that.$pageType == that.$enumPageType.t4
      ) {
        sendMessageImg =
          "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon3.png";
      } else if (that.$pageType == that.$enumPageType.vcard) {
        sendMessageImg =
          "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon4.png";
      }
      btnName = "领取链接";
      sendMessagePath = `/pages/webview/common/common?cuid=${that.cardInfo.User.Id
        }&url=${encodeURIComponent(
          webviewUrl
        )}&action=${action}&wxtitle=${encodeURIComponent(
          wxtitle
        )}&wxdesc=${encodeURIComponent(wxdesc)}&wxurl=${encodeURIComponent(
          wxurl
        )}&wxsmallpic=${encodeURIComponent(wxsmallpic)}`;

      // 导航到小程序中转页
      wx.miniProgram.navigateTo({
        url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
          btnName
        )}&sendMessageTitle=${encodeURIComponent(
          sendMessageTitle
        )}&sendMessageImg=${encodeURIComponent(
          sendMessageImg
        )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
      });
    } else {
      // 未关注
      this.getPartnerQrcode(that).then(function (partnerQrcodeImgUrl) {
        wxtitle = that.pageInfo.BrowserTabTitle;
        action = "qr_subscribe_gzh_hdk";
        sendMessageTitle = "关注很多客公众号，解锁更多AI获客神器功能";
        // sendMessageImg = "https://assets.wxmp.ruthus.com/henduoke/share_moments/icon5.png";
        sendMessageImg =
          "https://assets.wxmp.ruthus.com/henduoke/share_moments/icon3.png";
        btnName = "领取链接";
        if (
          that.$pageType == that.$enumPageType.t3 ||
          that.$pageType == that.$enumPageType.t4
        ) {
          pageType = 0;
        } else if (that.$pageType == that.$enumPageType.vcard) {
          pageType = 1;
        }
        // 组合发到客服消息的小程序链接,前面已经把分享信息设置到了 global_ 直接取用
        sendMessagePath = `/pages/webview/common/common?cuid=${that.cardInfo.User.Id
          }&url=${encodeURIComponent(
            webviewUrl
          )}&action=${action}&pageType=${pageType}&wxtitle=${encodeURIComponent(
            wxtitle
          )}&wxurl=${encodeURIComponent(webviewUrl)}&gzhid=${that.cardInfo.AppGzh.Id
          }&pageid=${that.pageInfo.PageId}`;
        if (partnerQrcodeImgUrl) {
          sendMessagePath += `&developPartnerQr=${partnerQrcodeImgUrl}`;
        }

        // 导航到小程序中转页
        wx.miniProgram.navigateTo({
          url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
            btnName
          )}&sendMessageTitle=${encodeURIComponent(
            sendMessageTitle
          )}&sendMessageImg=${encodeURIComponent(
            sendMessageImg
          )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
        });
      });
    }
  },
  /**
   * 5-1、分享当前页面，带默认传播信息，如果未关注回复二维码 在线售楼中心
   * @param {*} that vue实例
   */
  zxslzxNavigateToShareMomentsCurrentPageNoFollowReturnQrCode: function (that) {
    // 组合小程序webview链接
    let webviewUrl = this.getCurrentUrl();
    let currentUrlParam = this.getParamFromUrl(location.href);
    currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
    currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
    webviewUrl += "?" + this.objToUrlParam(currentUrlParam);

    // 组合朋友圈打开链接
    let wxtitle = "",
      wxdesc = "",
      wxsmallpic = "",
      wxurl = "";
    let sendMessagePath = "",
      sendMessageTitle = "",
      sendMessageImg = "",
      btnName = "",
      action = "h5share",
      pageType = "";
    if (that.userInfo && that.userInfo.user && that.userInfo.user.state == 1) {
      // 已关注
      wxtitle = sendMessageTitle = that.global.SHARE_TITLE;
      wxdesc = that.global.SHARE_DESC;
      wxsmallpic = that.global.SHARE_IMG_URL;
      wxurl = webviewUrl;
      sendMessageImg =
        "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon3.png";
      // sendMessageImg = "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon4.png";
      btnName = "领取链接";
      sendMessagePath = `/pages/webview/common/common?url=${encodeURIComponent(
        webviewUrl
      )}&action=${action}&wxtitle=${encodeURIComponent(
        wxtitle
      )}&wxdesc=${encodeURIComponent(wxdesc)}&wxurl=${encodeURIComponent(
        wxurl
      )}&wxsmallpic=${encodeURIComponent(wxsmallpic)}`;

      // 导航到小程序中转页
      wx.miniProgram.navigateTo({
        url: `/pages/share_moments/share_moments?btnName=${encodeURIComponent(
          btnName
        )}&sendMessageTitle=${encodeURIComponent(
          sendMessageTitle
        )}&sendMessageImg=${encodeURIComponent(
          sendMessageImg
        )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
      });
    } else {
      /**
       * action是resp_imagetxt， 参数是 fileUrl （图片url）,  txt  (返回的文案，如扫码关注之类的
       */
      request
        .get(global_.API_URL, {
          action: "getConfig"
        })
        .then(data => {
          if (data.code == 0 && data.obj && data.obj.app_qrurl) {
            // 未关注
            wxtitle = that.pageInfo.BrowserTabTitle;
            action = "resp_imagetxt";
            sendMessageTitle = "关注公众号，解锁更多AI功能";
            // sendMessageImg = "https://assets.wxmp.ruthus.com/henduoke/share_moments/icon5.png";
            sendMessageImg =
              "https://assets.wxmp.ruthus.com/henduoke/share_moments/icon3.png";
            btnName = "领取链接";

            // 组合发到客服消息的小程序链接,前面已经把分享信息设置到了 global_ 直接取用
            sendMessagePath = `/pages/webview/common/common?url=${encodeURIComponent(
              webviewUrl
            )}&action=${action}&wxtitle=${encodeURIComponent(
              wxtitle
            )}&wxurl=${encodeURIComponent(webviewUrl)}&gzhid=${that.userInfo.user.appid
              }&pageid=${that.pageInfo.PageId}`;
            sendMessagePath += `&fileUrl=${encodeURIComponent(
              data.obj.app_qrurl
            )}`;
            sendMessagePath += `&txt=${encodeURIComponent(
              "为了更好的为您服务，请扫码"
            )}`;
            // 导航到小程序中转页
            wx.miniProgram.navigateTo({
              url: `/pages/share_moments/share_moments?btnName=${encodeURIComponent(
                btnName
              )}&sendMessageTitle=${encodeURIComponent(
                sendMessageTitle
              )}&sendMessageImg=${encodeURIComponent(
                sendMessageImg
              )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
            });
          }
        });
    }
  },
  zxslzxNavigateToShareMomentsRespImageTxt(that, fileUrl) {
    console.log("我要zq", fileUrl);
    // 组合小程序webview链接
    let webviewUrl = this.getCurrentUrl();
    let currentUrlParam = this.getParamFromUrl(location.href);
    currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
    currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
    webviewUrl += "?" + this.objToUrlParam(currentUrlParam);

    // 组合朋友圈打开链接
    let wxtitle = "",
      wxdesc = "",
      wxsmallpic = "",
      wxurl = "";
    let sendMessagePath = "",
      sendMessageTitle = "",
      sendMessageImg = "",
      btnName = "",
      action = "h5share",
      pageType = "";
    // 未关注
    wxtitle = that.pageInfo.BrowserTabTitle;
    action = "resp_imagetxt";
    sendMessageTitle = "关注公众号，解锁更多AI功能";
    sendMessageImg =
      "https://assets.rurushishi.com/web8245/wxd4c280bb15760f39/1581672984000-5.jpeg";
    btnName = "领取链接";

    // 组合发到客服消息的小程序链接,前面已经把分享信息设置到了 global_ 直接取用
    sendMessagePath = `/pages/webview/common/common?url=${encodeURIComponent(
      webviewUrl
    )}&action=${action}&wxtitle=${encodeURIComponent(
      wxtitle
    )}&wxurl=${encodeURIComponent(webviewUrl)}&gzhid=${that.userInfo.user.appid
      }&pageid=${that.pageInfo.PageId}`;
    sendMessagePath += `&fileUrl=${encodeURIComponent(fileUrl)}`;
    sendMessagePath += `&txt=${encodeURIComponent(
      "为了更好的为您服务，请扫码"
    )}`;
    // 导航到小程序中转页
    wx.miniProgram.navigateTo({
      url: `/pages/share_moments/share_moments?btnName=${encodeURIComponent(
        btnName
      )}&sendMessageTitle=${encodeURIComponent(
        sendMessageTitle
      )}&sendMessageImg=${encodeURIComponent(
        sendMessageImg
      )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
    });
  },
  /**
   * 6、分享图片
   * @param {*} that vue实例
   * @param {Object} shareObj action,sendMessageTitle,sendMessageImg
   * action: qr_subscribe_gzh_hdk qr_subscribe_gzh_hdb qr_wxrobot
   */
  navigateToShareMomentsPageReturnImg: function (that, shareObj, imgUrl) {
    let that2 = this;
    if (!shareObj) {
      shareObj = {};
    }
    if (!shareObj.sendMessageTitle) {
      shareObj.sendMessageTitle = that.global.SHARE_TITLE;
    }
    if (!shareObj.sendMessageImg) {
      shareObj.sendMessageImg = that.global.SHARE_IMG_URL;
    }

    let sendMessagePath = "";
    if (shareObj.action == "qr_subscribe_gzh_hdk") {
      that2.getPartnerQrcode(that).then(function (partnerQrcodeImgUrl) {
        // 组合小程序webview链接
        let webviewUrl = that2.getCurrentUrl();
        let currentUrlParam = that2.getParamFromUrl(location.href);
        currentUrlParam.refereeopenid = that.shareSpreadInfo.refereeopenid;
        currentUrlParam.rscuid = that.shareSpreadInfo.rscuid;
        webviewUrl += "?" + that2.objToUrlParam(currentUrlParam);

        let pageType = "",
          wxtitle = "";
        if (
          that.$pageType == that.$enumPageType.t3 ||
          that.$pageType == that.$enumPageType.t4
        ) {
          pageType = 0;
        } else if (that.$pageType == that.$enumPageType.vcard) {
          pageType = 1;
        }
        wxtitle = that.pageInfo.BrowserTabTitle;
        sendMessagePath = `/pages/hdk/intro/intro?action=${shareObj.action
          }&pageType=${pageType}&wxtitle=${encodeURIComponent(
            wxtitle
          )}&wxurl=${encodeURIComponent(webviewUrl)}&gzhid=${that.cardInfo.AppGzh.Id
          }&pageid=${that.pageInfo.PageId}`;
        if (partnerQrcodeImgUrl) {
          sendMessagePath += `&developPartnerQr=${partnerQrcodeImgUrl}`;
        }
        // 跳转到小程序中转页
        wx.miniProgram.navigateTo({
          url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
            "领取二维码"
          )}&sendMessageTitle=${encodeURIComponent(
            shareObj.sendMessageTitle
          )}&sendMessageImg=${encodeURIComponent(
            shareObj.sendMessageImg
          )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
        });
      });
    } else {
      sendMessagePath = `/pages/hdk/intro/intro?action=${shareObj.action}`;
      // 跳转到小程序中转页
      wx.miniProgram.navigateTo({
        url: `/pages/hdk/share_moments/share_moments?btnName=${encodeURIComponent(
          "领取二维码"
        )}&sendMessageTitle=${encodeURIComponent(
          shareObj.sendMessageTitle
        )}&sendMessageImg=${encodeURIComponent(
          shareObj.sendMessageImg
        )}&sendMessagePath=${encodeURIComponent(sendMessagePath)}`
      });
    }
  },
  /**
   * 获取发展伙伴小程序码 返回小程序码的图片路径
   */
  getPartnerQrcode(that) {
    return new Promise(function (resolve, reject) {
      if (
        that.hdkUserInfo &&
        that.hdkUserInfo.User &&
        that.hdkUserInfo.User.Id &&
        that.hdkUserInfo.AppGzh &&
        that.hdkUserInfo.AppGzh.Id
      ) {
        let postObj = {
          uid: that.hdkUserInfo.User.Id,
          page: "pages/hdk/register/register",
          scene: JSON.stringify({
            pid: that.hdkUserInfo.AppGzh.Id,
            fuid: that.hdkUserInfo.User.Id,
            ouid: that.hdkUserInfo.User.Id,
            cuid: that.hdkUserInfo.User.Id,
            channel: "scan_qrcode_partner",
            pageParam: null
          })
        };
        request
          .post2(global_.API_URL_HDK + "open/wx/acode", postObj)
          .then(function (res) {
            resolve(res.data);
          });
      } else {
        resolve("");
      }
    });
  },
  /**
   * 获取发展伙伴小程序码 返回小程序码的scene
   */
  getPartnerQrcode2(that, qrcodeHdkUserId) {
    return new Promise(function (resolve, reject) {
      if (
        that.hdkUserInfo &&
        that.hdkUserInfo.AppGzh &&
        that.hdkUserInfo.AppGzh.Id
      ) {
        let postObj = {
          uid: qrcodeHdkUserId,
          page: "pages/hdk/register/register",
          scene: JSON.stringify({
            pid: that.hdkUserInfo.AppGzh.Id,
            fuid: qrcodeHdkUserId,
            ouid: qrcodeHdkUserId,
            cuid: qrcodeHdkUserId,
            channel: "scan_qrcode_partner",
            pageParam: null
          })
        };
        request
          .post2(global_.API_URL_HDK + "open/wx/acodeWithId", postObj)
          .then(function (res) {
            resolve(res.data);
          });
      } else {
        resolve("");
      }
    });
  },
  // 客户端信息
  clientInfo: (function () {
    let attrs = [
      "appCodeName",
      "appName",
      "appVersion",
      "cookieEnabled",
      "language",
      "platform",
      "product",
      "vendor"
    ];
    let str = "";
    attrs.forEach(function (e, i) {
      str += e + ":" + navigator[e] + ";";
    });
    return str;
  })(),
  // 弹框
  messageBox: function (msg) {
    return new Promise(function (resolve, reject) {
      MessageBox.alert(
        `<div style='-webkit-user-select: text;-khtml-user-select: text;-moz-user-select: text;-ms-user-select: text;user-select: text;'><div style='-webkit-user-select: text-khtml-user-select: text;-moz-user-select: text;-ms-user-select: text;user-select: text;'>${msg}</div></div>`
      ).then(() => {
        resolve();
      });
    });
  },
  /**
   * 打开聊天
   * #### 聊天20190711

##### 模板消息打开聊天：
source是必须的 其他的 你不传 我就不会启动自动撩客，

1、打开是小程序：  

1.1 之前建立过聊天室：
/pages/chat/dialog/dialog?pid=(很多客行业id)&fuid=(很多客小程序传播者用户id)&ouid=(很多客中介用户id)&fid=(聊天对象的unionid)

1.2 之前未建立过聊天室
/pages/chat/dialog/dialog?pid=(很多客行业id)&fuid=(很多客小程序传播者用户id)&ouid=(很多客中介用户id)&fid=(聊天对象的unionid)&addparam={
    source:（来源：1名片；2内容；3同行发布；4海报；5很多宝），
    section：（第三方场景标记，source=2 是PageId），
    contentType：（来源类型：1地产 2其他），
    contentTitle：（来源标题）
}

2、打开是网页：

2.1 之前建立过聊天室：
http://henduoke.quanc.com.cn/yqim/chat?fid=(聊天对象的unionid)

2.2 之前未建立过聊天室：
http://henduoke.quanc.com.cn/yqim/chat?fid=(聊天对象的unionid)&addparam={
    source:（来源：1名片；2内容；3同行发布；4海报；5很多宝），
    section：（第三方场景标记，source=2 是PageId），
    contentType：（来源类型：1地产 2其他），
    contentTitle：（来源标题）
}



##### 程序界面打开聊天：

1、很多宝

参考《模板消息打开聊天》2.2

2、很多客内容和名片页面
参考《模板消息打开聊天》1.2 2.2
   * @param {*} that 
   */
  openChat(that) {
    if (that.cardInfo.Wxuser.Unionid == that.userInfo.user.unionid) {
      this.messageBox("您不能与自己聊天！");
      return;
    }
    let url = "",
      addparam = null;
    if (
      that.$pageType == that.$enumPageType.t3 ||
      that.$pageType == that.$enumPageType.t4
    ) {
      addparam = {
        source: 2,
        section: that.pageInfo.PageId || "",
        contentType: 1,
        contentTitle: that.pageInfo.BrowserTabTitle || ""
      };
    } else if (that.$pageType == that.$enumPageType.vcard) {
      addparam = {
        source: 1,
        section: that.pageInfo.PageId || "",
        contentType: 1,
        contentTitle: that.pageInfo.BrowserTabTitle || ""
      };
    }
    if (that.isInMiniProgram) {
      // 小程序聊天还传对方的 Unionid
      url = `/pages/chat/dialog/dialog?fid=${that.cardInfo.Wxuser.Unionid
        }&addparam=${encodeURIComponent(JSON.stringify(addparam))} `;
      wx.miniProgram.navigateTo({
        url: url
      });
    } else {
      let myHost = "";
      if (global_.isLoc) {
        myHost = "henduoke.quanc.com.cn";
      } else {
        myHost = location.host;
      }
      // 聊天的地址不用是https
      url = `http://${myHost}/yqim/chat?fid=${that.cardInfo.Wxuser.Unionid
        }&addparam=${encodeURIComponent(JSON.stringify(addparam))}`;
      if (global_.isLoc) {
        console.log("聊天链接为：", {
          url: url
        });
      } else {
        location.href = url;
      }
    }
  },
  /**
   * 打开抽奖
   * @param {*} that
   * @param {*} item
   */
  openDraw(that, url) {
    if (that.isInMiniProgram) {
      // 在小程序里打开
      wx.miniProgram.navigateTo({
        url: `/pages/webview/common/common?url=${encodeURIComponent(url)}`
      });
    } else {
      location.href = url;
    }
  },
  /**
   * 提示框
   * @param {*} msg
   * @param {*} duration
   */
  showToast(msg, duration = 2000) {
    Toast({
      message: msg,
      duration: duration
    });
  },
  /**
   * 取随机数
   * @param {*} minNum
   * @param {*} maxNum
   */
  randomNum(minNum, maxNum) {
    switch (arguments.length) {
      case 1:
        return parseInt(Math.random() * minNum + 1, 10);
        break;
      case 2:
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
        break;
      default:
        return 0;
        break;
    }
  },
  /**
   * 计算字符串长度(英文占1个字符，中文汉字占2个字符)
   * @param {*} str
   */
  getStrBlen(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  },
  /**
   * 换成我的
   */
  switchToMine(that) {
    let that2 = this;
    return new Promise(function (resolve, reject) {
      if (that.hdkUserInfo.isRegister) {
        if (that.isInMiniProgram) {
          // 已注册，跳转到自己的小程序
          let h5url = "";
          if (that.$pageType == that.$enumPageType.t3) {
            h5url = `https://${location.host}/h5/t3?id=${that.$route.query.id
              }&psn=${that.$route.query.psn}&refereeopenid=${that.$openid
              }&rscuid=${that.$openid}`;
          } else if (that.$pageType == that.$enumPageType.t4) {
            h5url = `https://${location.host}/h5/t4?id=${that.$route.query.id
              }&psn=${that.$route.query.psn}&refereeopenid=${that.$openid
              }&rscuid=${that.$openid}`;
          } else if (that.$pageType == that.$enumPageType.vcard) {
            h5url = `https://${location.host}/h5/vcard?refereeopenid=${that.$openid
              }&rscuid=${that.$openid}`;
          }
          wx.miniProgram.redirectTo({
            url: `/pages/webview/common/common?url=${encodeURIComponent(
              h5url
            )}&cuid=${that.hdkUserInfo.User.Id}`
          });
        } else {
          // 已注册，换名片信息，重置分享
          that.SET_CARDINFO(that.hdkUserInfo);
          that.SET_SHARESPREADINFO({
            id: that.$route.query.id,
            psn: that.$route.query.psn,
            refereeopenid: that.$openid,
            rscuid: that.$openid
          });
          if (that.$pageType == that.$enumPageType.t3) {
            that2.setFoundShare(that.pageInfo, that.shareSpreadInfo);
          } else if (that.$pageType == that.$enumPageType.t4) {
            that2.setFoundShare(that.pageInfo, that.shareSpreadInfo);
          } else if (that.$pageType == that.$enumPageType.vcard) {
            that2.setVcardShare(that, that.shareSpreadInfo);
          }
          that2.messageBox("更换成功！");
          resolve(1);
        }
      } else {
        if (that.isInMiniProgram) {
          // 未注册，跳转到注册页
          that2.openMinProgramRegister(that);
          resolve(3);
        } else {
          // 未注册，获取注册页小程序码
          resolve(4);
        }
      }
    });
  },
  openMinProgramRegister(that) {
    wx.miniProgram.navigateTo({
      url: `/pages/hdk/register/register?backurl=vcard`
    });
  },
  /**
   * 是否是数组
   */
  isArray(o) {
    return Object.prototype.toString.call(o) === "[object Array]";
  },
  // 打开内容页
  openFound(that, item) {
    let h5url = `https://${location.host}/h5/t${item.templateno}?id=${item.id
      }&psn=${item.psn}&refereeopenid=${that.$openid}&rscuid=${that.$openid}`;
    if (!that.isShowGuide) {
      h5url += "&noguide=1";
    }
    if (that.isInMiniProgram) {
      wx.miniProgram.navigateTo({
        url: `/pages/webview/common/common?cuid=${that.cardInfo.User.Id
          }&url=${encodeURIComponent(h5url)}`
      });
    } else {
      this.openUrl(h5url);
    }
  },
  // 获取公众号聊天的Url
  getGzhChatUrl(that) {
    let url = "";
    if (that.isInMiniProgram) {
      url = "https://";
    } else {
      url = "http://";
    }
    url += `${that.global.DOMAIN}/yqim/chat?`;
    // 很多宝的聊天
    if (that.global.SUBDOMAIN == "henduobao") {
      url += `fid=oGUrTwfK9ZRhYQR8ysFiBTNOCwzA`;
    } else if (that.global.SUBDOMAIN == "henduoke" && that.$refereeopenid) {
      url += `fid=${that.$refereeopenid}`;
    } else if (
      that.$refereeopenid &&
      that.userInfo &&
      that.userInfo.user &&
      that.userInfo.user.openid &&
      that.userInfo.user.passport &&
      that.pageInfo &&
      that.pageInfo.PageId
    ) {
      url = `${location.protocol}//${location.host
        }/newcode/src/chat_room.html?openid=${that.userInfo.user.openid
        }&passport=${that.userInfo.user.passport}&receiveropenid=${that.$refereeopenid
        }&pageid=${that.pageInfo.PageId}&projectid=${that.pageInfo.Pid}`;
    } else {
      url = "";
    }
    return url;
  },
  formatDateLikeWx: function (dateTime) {
    //2017-12-25 15:57:50
    //原始时间
    var strOrgDateTime = "2017-12-24 12:57:50";
    strOrgDateTime = dateTime;
    var orgObj = {
      yy: strOrgDateTime.substring(0, 4),
      mm: strOrgDateTime.substring(5, 7),
      dd: strOrgDateTime.substring(8, 10),
      h: strOrgDateTime.substring(11, 13),
      m: strOrgDateTime.substring(14, 16),
      s: strOrgDateTime.substring(17, 19)
    };
    //当前时间
    var strNowDateTime = this.getFullTime(new Date());
    var nowObj = {
      yy: strNowDateTime.substring(0, 4),
      mm: strNowDateTime.substring(5, 7),
      dd: strNowDateTime.substring(8, 10),
      h: strNowDateTime.substring(11, 13),
      m: strNowDateTime.substring(14, 16),
      s: strNowDateTime.substring(17, 19)
    };
    var date1 = new Date(strOrgDateTime); //开始时间
    var date2 = new Date(strNowDateTime); //结束时间
    var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
    //计算出相差天数
    var days = Math.floor(date3 / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000);

    var newStr = "";

    if (leave2 < 60) {
      newStr = leave2 + "分钟前";
    } else if (leave1 < 24) {
      newStr = leave1 + "小时前";
    } else if (parseInt(orgObj.h) >= 0 && parseInt(orgObj.h) <= 5) {
      newStr = "凌晨" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 6 && parseInt(orgObj.h) <= 10) {
      newStr = "上午" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 11 && parseInt(orgObj.h) <= 13) {
      newStr = "中午" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 14 && parseInt(orgObj.h) <= 17) {
      newStr = "下午" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 18 && parseInt(orgObj.h) <= 23) {
      newStr = "晚上" + orgObj.h + ":" + orgObj.m;
    } else {
      newStr = orgObj.h + ":" + orgObj.m;
    }

    if (days == 1) {
      //昨天
      newStr = "昨天 " + newStr;
    } else if (
      this.isSameWeek(
        new Date(date1.setDate(date1.getDate() - 1)),
        new Date(date2)
      )
    ) {
      //同一周
      var weeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      newStr = weeks[date1.getDay() + 1] + " " + newStr;
    } else if (nowObj.yy == orgObj.yy) {
      //同一年
      newStr = orgObj.mm + "月" + orgObj.dd + "日 " + newStr;
    } else {
      newStr = orgObj.yy + "年" + orgObj.mm + "月" + orgObj.dd + "日 " + newStr;
    }

    return newStr;
  },
  getFullTime: function (time) {
    var date = new Date(time);
    var m = date.getMonth() + 1;
    m <= 9 ? (m = "0" + m) : m;
    var d = date.getDate();
    d <= 9 ? (d = "0" + d) : d;
    var h = date.getHours();
    h <= 9 ? (h = "0" + h) : h;
    var m2 = date.getMinutes();
    m2 <= 9 ? (m2 = "0" + m2) : m2;
    var s = date.getSeconds();
    s <= 9 ? (s = "0" + s) : s;
    return (
      date.getFullYear() + "-" + m + "-" + d + " " + h + ":" + m2 + ":" + s
    );
  },
  isSameWeek: function (old, now) {
    var oneDayTime = 1000 * 60 * 60 * 24;
    var old_count = parseInt(old.getTime() / oneDayTime);
    var now_other = parseInt(now.getTime() / oneDayTime);
    return parseInt((old_count + 4) / 7) == parseInt((now_other + 4) / 7);
  },
  isSameThehour: function (org, now) {
    var strOrgDateTime = org;
    var orgObj = {
      yy: strOrgDateTime.substring(0, 4),
      mm: strOrgDateTime.substring(5, 7),
      dd: strOrgDateTime.substring(8, 10),
      h: strOrgDateTime.substring(11, 13),
      m: strOrgDateTime.substring(14, 16),
      s: strOrgDateTime.substring(17, 19)
    };
    //当前时间
    var strNowDateTime = now;
    var nowObj = {
      yy: strNowDateTime.substring(0, 4),
      mm: strNowDateTime.substring(5, 7),
      dd: strNowDateTime.substring(8, 10),
      h: strNowDateTime.substring(11, 13),
      m: strNowDateTime.substring(14, 16),
      s: strNowDateTime.substring(17, 19)
    };
    var newStr = false;
    if (
      parseInt(orgObj.h) >= 0 &&
      parseInt(orgObj.h) <= 5 &&
      parseInt(nowObj.h) >= 0 &&
      parseInt(nowObj.h) <= 5
    ) {
      newStr = true;
    } else if (
      parseInt(orgObj.h) >= 6 &&
      parseInt(orgObj.h) <= 10 &&
      parseInt(nowObj.h) >= 6 &&
      parseInt(nowObj.h) <= 10
    ) {
      newStr = true;
    } else if (
      parseInt(orgObj.h) >= 11 &&
      parseInt(orgObj.h) <= 13 &&
      parseInt(nowObj.h) >= 11 &&
      parseInt(nowObj.h) <= 13
    ) {
      newStr = true;
    } else if (
      parseInt(orgObj.h) >= 14 &&
      parseInt(orgObj.h) <= 17 &&
      parseInt(nowObj.h) >= 14 &&
      parseInt(nowObj.h) <= 17
    ) {
      newStr = true;
    } else if (
      parseInt(orgObj.h) >= 18 &&
      parseInt(orgObj.h) <= 23 &&
      parseInt(nowObj.h) >= 18 &&
      parseInt(nowObj.h) <= 23
    ) {
      newStr = true;
    }
    return newStr;
  },
  makePhoneCall(phone) {
    location.href = "tel:" + phone;
  },
  getIsAcglr(userInfo) {
    let is2015 = false;
    if (userInfo.role && userInfo.role.length > 0) {
      userInfo.role.forEach(item => {
        if (item.roleid == 2015) {
          is2015 = true;
        }
      });
    }
    return is2015;
  },

  //获取用户电话
  getUserMobile(userInfo) {
    let mobile = "";
    if (userInfo.fansInfo && userInfo.fansInfo.ui_mobile) {
      mobile = userInfo.fansInfo.ui_mobile;
    } else if (userInfo.fansInfo && userInfo.fansInfo.mobile) {
      mobile = userInfo.fansInfo.mobile;
    } else if (userInfo.user && userInfo.user.mobile) {
      mobile = userInfo.user.mobile;
    }
    return mobile;
  },

  //获取用户头像
  getUserHeadimg(userInfo) {
    let headimg =
      "http://assets.rurushishi.com/yq-rs-make/huafa/default-head.png";
    if (userInfo.fansInfo && userInfo.fansInfo.ui_headimg) {
      headimg = userInfo.fansInfo.ui_headimg;
    } else if (userInfo.fansInfo && userInfo.fansInfo.headimgurl) {
      headimg = userInfo.fansInfo.headimgurl;
    } else if (userInfo.user && userInfo.user.headimgurl) {
      headimg = userInfo.user.headimgurl;
    }
    return headimg;
  },

  //获取用户昵称
  getUserName(userInfo) {
    let username = "";
    if (userInfo.fansInfo && userInfo.fansInfo.ui_name) {
      username = userInfo.fansInfo.ui_name;
    } else if (userInfo.fansInfo && userInfo.fansInfo.name) {
      username = userInfo.fansInfo.name;
    } else if (userInfo.user) {
      username = userInfo.user.name || userInfo.user.nickname || "";
    }
    return username;
  },

  //获取全民经纪人类型
  getHfAgentUserType(status) {
    switch (status) {
      case "10":
        return "全民经纪人";
        break;
      case "20":
        return "机构";
        break;
      case "30":
        return "业主";
        break;
      case "40":
        return "员工";
        break;
      case "50":
        return "拓客";
        break;
      default:
        return "";
        break;
    }
  },

  //des加密
  encryptDes(message, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },

  getMakeLink(url) {
    let link = this.addUrlParamFromObj(
      url,
      myVue.$store.state.receiveSpreadInfo
    );
    return link;
  },

  /**
   * 获取华发全面营销地址
   微信标识_操作_电话_项目id_在线售楼openid_城市
   wx=&action=&mobile=&projectid=&openid=&city=
   */
  getHfYxUrl(act, mobile, pid, backurl) {
    let city = Cookies.get("hf_cur_city_name")
      ? Cookies.get("hf_cur_city_name")
      : "";
    let openid = Cookies.get("openid") ? Cookies.get("openid") : "";

    let rbackurl = encodeURIComponent(this.getMakeLink(backurl));
    console.log("返回backurl>>>", backurl);
    let redirect_uri = encodeURIComponent(
      `${global_.HF_YXCONFIG.url}?wx=${global_.HF_YXCONFIG.bs
      }&act=${act}&mobile=${mobile}&projectid=${pid}&openid=${openid}&city=${city}&backurl=${rbackurl}`
    );
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${global_.HF_YXCONFIG.appid
      }&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
    // let state = `${global_.HF_YXCONFIG.bs}_ff_${act}_ff_${mobile}_ff_${pid}_ff_${openid}_ff_${city}`
    console.log("华发营销redirect_uri>>>", redirect_uri);
    // state = this.encryptDes(state, 'onlineSales20200308')
    // state = encodeURIComponent(state)
    // console.log('加密后的state>>>',state)
    // url = url.replace('{STATE}', state)
    console.log("华发营销url>>>", url);
    return url;
  },
  /**
   * 验证两个object 是否相同
   * @param {Object} obj  [需要进行验证的数据1]
   * @param {Object} newObj [需要进行验证的数据2]
   */
  objSame(obj, newObj) {
    let bol = true;
    if (Object.keys(obj).length != Object.keys(newObj).length) {
      return false;
    }
    for (let key in obj) {
      if (obj[key] instanceof Object) {
        bol = this.objSame(obj[key], newObj[key]);
        if (!bol) {
          break;
        }
      } else if (obj[key] instanceof Array) {
        bol = this.arrSame(obj[key], newObj[key]);
        if (!bol) {
          break;
        }
      } else if (obj[key] != newObj[key]) {
        bol = false;
        break;
      }
    }
    return bol;
  },
  /**
   * 验证两个数组是否相同
   * @param {Array} arr  [需要进行验证的数据1]
   * @param {Array} newArr [需要进行验证的数据2]
   */
  arrSame(arr, newArr) {
    let bol = true;
    if (arr.length != newArr.length) {
      return false;
    }
    for (let i = 0, n = arr.length; i < n; i++) {
      if (arr[i] instanceof Array) {
        bol = this.arrSame(arr[i], newArr[i]);
        if (!bol) {
          break;
        }
      } else if (arr[i] instanceof Object) {
        bol = this.objSame(arr[i], newArr[i]);
        if (!bol) {
          break;
        }
      } else if (arr[i] != newArr[i]) {
        bol = false;
        break;
      }
    }
    return bol;
  },
  filterUserInfoAndFansInfo(userInfo, fansInfo) {
    userInfo.fansInfo = fansInfo;
    userInfo.ui = {
      name: fansInfo.ui_name || fansInfo.name || fansInfo.nickname,
      mobile: fansInfo.ui_mobile || fansInfo.mobile,
      headimg:
        fansInfo.ui_headimg ||
        fansInfo.headimgurl ||
        userInfo.user.headimg ||
        userInfo.user.headimgurl ||
        "http://assets.rurushishi.com/yq-rs-make/huafa/default-head.png",
      company:
        fansInfo.ui_company && fansInfo.ui_company != "null"
          ? fansInfo.ui_company
          : fansInfo.projectname && fansInfo.projectname != "null"
            ? fansInfo.projectname
            : "",
      wechatno: fansInfo.ui_weixin,
      wechatqrcode: fansInfo.wxqr
    };
    return userInfo;
  },
  filterObjRemoveUndef(obj) {
    let newObj = {};
    Object.keys(obj).forEach(key => {
      if (obj[key] != undefined) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  },
  checkIsRsH5(url) {
    if (
      url.indexOf("/h5/t1.html") > -1 ||
      url.indexOf("/h5/t2.html") > -1 ||
      url.indexOf("/h5/tp1.html") > -1 ||
      url.indexOf("/h5/t10.html") > -1
    ) {
      return true;
    }
    return false;
  },
  getXcxActAreasPath(that, type, id, psn) {
    let pathType = "";
    switch (type) {
      case "buy":
        pathType = 1;
        break;
      case "free":
        pathType = 2;
        break;
    }
    if (
      (id || that.receiveSpreadInfo.id) &&
      (psn || that.receiveSpreadInfo.psn) &&
      that.userInfo &&
      that.userInfo.user &&
      that.userInfo.user.appid &&
      that.userInfo.user.openid &&
      that.pageInfo &&
      that.pageInfo.Pid
    ) {
      let path = `src/pages/index/pages/partake/index.html?id=${id ||
        that.receiveSpreadInfo.id}&psn=${psn ||
        that.receiveSpreadInfo.psn}&appId=${that.userInfo.user.appid}&pid=${that.pageInfo.Pid
        }&type=${pathType}&gzhOpenId=${that.userInfo.user.openid}&share=1`;
      return path;
    }
    return "";
  },
  getMediaCssTxt() {
    return "<style>@media only screen and (min-width:320px){html{font-size:42.66px!important}}@media only screen and (min-width:330px){html{font-size:44px!important}}@media only screen and (min-width:340px){html{font-size:45.33px!important}}@media only screen and (min-width:350px){html{font-size:46.67px!important}}@media only screen and (min-width:360px){html{font-size:48px!important}}@media only screen and (min-width:370px){html{font-size:49.33px!important}}@media only screen and (min-width:380px){html{font-size:50px!important}}@media only screen and (min-width:390px){html{font-size:52px!important}}@media only screen and (min-width:400px){html{font-size:53.33px!important}}@media only screen and (min-width:410px){html{font-size:54.66px!important}}@media only screen and (min-width:420px){html{font-size:56px!important}}@media only screen and (min-width:430px){html{font-size:57.33px!important}}@media only screen and (min-width:440px){html{font-size:58.67px!important}}@media only screen and (min-width:450px){html{font-size:60px!important}}@media only screen and (min-width:460px){html{font-size:61.33px!important}}@media only screen and (min-width:470px){html{font-size:62.66px!important}}@media only screen and (min-width:480px){html{font-size:64px!important}}@media only screen and (min-width:490px){html{font-size:65.33px!important}}@media only screen and (min-width:500px){html{font-size:66.67px!important}}@media only screen and (min-width:510px){html{font-size:68px!important}}@media only screen and (min-width:520px){html{font-size:69.33px!important}}@media only screen and (min-width:530px){html{font-size:70.66px!important}}@media only screen and (min-width:540px){html{font-size:72px!important}}@media only screen and (min-width:550px){html{font-size:73.33px!important}}@media only screen and (min-width:560px){html{font-size:74.66px!important}}@media only screen and (min-width:570px){html{font-size:76px!important}}@media only screen and (min-width:580px){html{font-size:77.33px!important}}@media only screen and (min-width:590px){html{font-size:78.66px!important}}@media only screen and (min-width:600px){html{font-size:80px!important}}@media only screen and (min-width:610px){html{font-size:81.33px!important}}@media only screen and (min-width:620px){html{font-size:82.66px!important}}@media only screen and (min-width:630px){html{font-size:84px!important}}@media only screen and (min-width:640px){html{font-size:85.33px!important}}@media only screen and (min-width:720px){html{font-size:96px!important}}</style>";
  },
  /**
   * h5打开小程序需要路径是.html
   * @param {*} oldPath
   */
  handleH5OpenMpPath(oldPath) {
    let oldPathUrl = this.getUrlRemoveParams(oldPath);
    if (oldPathUrl.endsWith(".html")) {
      return oldPath;
    }
    let newPath = this.addUrlParamFromObj(
      oldPathUrl + ".html",
      this.getParamFromUrl(oldPath)
    );
    return newPath;
  }
};
